import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useReporter } from '../../reporter';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  StyledLink,
  LinkIconContainer,
  FooterColumnLink,
  StyledBlurb,
} from './styles';
import { footerLinkClicked } from './events';

export const BottomLink = ({ href, text, index }) => {
  const reporter = useReporter();
  const trackEvent = footerLinkClicked(text, href, 'Bottom', index);
  return (
    <Link href={href} passHref>
      <StyledLink onClick={() => reporter.tag(trackEvent)}>{text}</StyledLink>
    </Link>
  );
};

export const FooterLink = ({ href, text, icon, index, columnTitle, blurb }) => {
  const reporter = useReporter();
  const trackEvent = footerLinkClicked(text, href, columnTitle, index);
  return (
    <FooterColumnLink icon={!!icon}>
      {icon && (
        <LinkIconContainer>
          <ResponsiveImage
            src={icon.src}
            alt={icon.alt}
            width={17}
            height={17}
          />
        </LinkIconContainer>
      )}
      <Link href={href} passHref>
        <StyledLink onClick={() => reporter.tag(trackEvent)}>{text}</StyledLink>
      </Link>
      {blurb && <StyledBlurb> {blurb}</StyledBlurb>}
    </FooterColumnLink>
  );
};

FooterLink.displayName = 'FooterLink';

FooterLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }),
  index: PropTypes.number.isRequired,
  columnTitle: PropTypes.string.isRequired,
  blurb: PropTypes.string,
};

BottomLink.displayName = 'BottomLink';

BottomLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};
